import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Footer from '../Common/Layout/Footer';
import APIConfig from "../Common/Configurations/APIConfig";
const initialFieldValues = {
    email: "",
    domainUrl: ""
};
export default function ResetPassword() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [errors, setErrors] = useState({});
    const [successStatus, setSuccessStatus] = useState('');
    const [errorStatus, setErrorStatus] = useState('');
    const [btnSubmit, setBtnSubmit] = useState(true);
    const [email, setEmail] = useState("");
    const [token, setToken] = useState("");
    const [password, setPassword] = useState("");
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken")
        }
    }
    const handleSubmit = (e) => {
        setBtnSubmit(false);
        e.preventDefault();
        if (password !== "") {
            const formData = new FormData()
            formData.append("email", email)
            formData.append("token", token.trim())
            formData.append("password", password)
            addOrEdit(formData);
        }
        else {
            setBtnSubmit(true);
            alert("Please enter password");
        }
    };
    const applicationAPI = () => {
        return {
            post: (newrecord) => axios.post(APIConfig.APIACTIVATEURL + APIConfig.RESETPASSWORD, newrecord, { ...headerconfig })
        };
    };
    const addOrEdit = (formData) => {
        applicationAPI()
            .post(formData)
            .then((res) => {
                if (res.data.statusCode === 200) {
                    setSuccessStatus(res.data.message);
                    setBtnSubmit(true);
                    setPassword("");
                    setErrorStatus('')
                }
                else {
                    setBtnSubmit(true);
                    if (res.data.response.data == "Invalid token.") {
                        setErrorStatus("Token Expired.");
                    }
                    else {
                        setErrorStatus(res.data.message);
                    }
                    setSuccessStatus('');
                }
            });
    };
    const applyErrorClass = (field) =>
        field in errors && errors[field] === false ? " form-control-danger" : "";
    useEffect(() => {
        if (searchParams === null) {
            navigate('/')
        }
        else {
            setEmail(searchParams.get("email"))
            var letparams = searchParams.toString();
            var splitparams = letparams.split('=')
            setToken(splitparams[2])
        }
    }, [])
    return (
        <>
            <div className="auth-back-cover" style={{ backgroundColor: "#39279D" }}>
                <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
                    {/* auth-page content */}
                    <div className="auth-page-content overflow-hidden mt-lg-4">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-5">
                                    <div className="card overflow-hidden rounded-4 loginbox">
                                        <div className="row g-0">
                                            <div className="p-lg-5 p-4">
                                                <div>
                                                    <img src="/assets/images/logo3d.jpg"></img>
                                                </div>
                                                <h4 className="mb-2">Reset Password</h4>
                                                {successStatus !== "" ? <div class="alert alert-info text-black"> <i class="fas fa-check-circle"></i> {successStatus}</div> : ""}
                                                {errorStatus !== "" ? <div class="alert alert-danger text-black"> <i class="fas fa-check-circle"></i> {errorStatus} </div> : ""}
                                                <div className="mt-4">
                                                    <form onSubmit={handleSubmit} className="mt-4 text-start" autoComplete="off" noValidate>
                                                        <div className="form">
                                                            <div className="mb-3">
                                                                <label htmlFor="email" className="form-label">Email</label>
                                                                <input disabled className={'form-control' + applyErrorClass('email')} name="email" type="text" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter Email" />
                                                                {errors.email === false ? (<div className="validationerror"> Please enter email </div>) : ('')}
                                                            </div>
                                                            <div className="mb-3">
                                                                <label htmlFor="email" className="form-label">New Password</label>
                                                                <input className={'form-control' + applyErrorClass('password')} name="password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter New Password" />
                                                                {errors.password === false ? (<div className="validationerror"> Please enter password </div>) : ('')}
                                                            </div>
                                                            <div className="mt-4 d-flex justify-content-end">
                                                                {btnSubmit === true ? (
                                                                    <button type="submit" className="btn btn-primary full-width font--bold btn-lg">Reset Password</button>
                                                                ) : (<button type="button" disabled className="btn btn-primary full-width font--bold btn-lg">Please wait...</button>)}
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                            {/* end col */}
                                        </div>
                                        {/* end row */}
                                    </div>
                                    {/* end card */}
                                </div>
                                {/* end col */}
                            </div>
                            {/* end row */}
                        </div>
                        {/* end container */}
                    </div>
                    {/* end auth page content */}
                </div>
            </div>
            <Footer></Footer>
        </>
    );
}
